import collection from '../../../api/collections/Status'
import asyncMiddleware from '../../../utils/action-handler'

export default {
  namespaced: true,
  state: {
    list: [],
    item: {},
    pagination: {}
  },
  mutations: {
    SET_STATUS(state, data) {
      state.list = data
    },
    SET_STATUS_ITEM(state, data) {
      state.item = data
    },
    RESET_STATUS(state, data) {
      state.item = {}
    },
    SET_STATUS_TABLE_PAGINATION(state, data) {
      state.pagination = data
    }
  },
  actions: {
    async GET_STATUS({ commit, dispatch }, payload) {
      return await asyncMiddleware(async function() {
        const { data } = await collection.get(payload)
        commit('SET_STATUS', data.data)
        return data
      }, commit, dispatch, 'GET_STATUS', true)
    },
  }
}
